import { render, staticRenderFns } from "./SortProductSelect.vue?vue&type=template&id=545fa72a"
import script from "./SortProductSelect.vue?vue&type=script&lang=ts"
export * from "./SortProductSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports